import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { dataFieldNamingHandler, exceptionHandler } from '../../base/decorators';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import QQShareRepository from '../repository/qq-share-repository';
import { IUserInfoDomainService } from '../../user-info/service/user-info-domain-service.interface';
import { ACCOUNT_TYPE } from '@tencent/ark-utils/lib/base/types';
var QQShareEntity = /** @class */ (function () {
    function QQShareEntity(docMetaDomainService, networkRequest, userInfoDomainService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequest = networkRequest;
        this.userInfoDomainService = userInfoDomainService;
        this.qqShareRepository = new QQShareRepository(docMetaDomainService, networkRequest, userInfoDomainService);
    }
    QQShareEntity.prototype.checkIfCanShare = function () {
        return __awaiter(this, void 0, void 0, function () {
            var loginType, shouldAddUFlag;
            return __generator(this, function (_a) {
                loginType = this.userInfoDomainService.userInfoAggregate.userInfo.loginType;
                shouldAddUFlag = ![ACCOUNT_TYPE.QQ, ACCOUNT_TYPE.WX].includes(loginType);
                return [2 /*return*/, this.qqShareRepository.checkIfCanShare(shouldAddUFlag)];
            });
        });
    };
    QQShareEntity.prototype.setTipsAfterImport = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.qqShareRepository.setTipsAfterImport(options)];
            });
        });
    };
    QQShareEntity.prototype.shareToQQOrTIM = function (uinList) {
        return __awaiter(this, void 0, void 0, function () {
            var loginType, shouldAddUFlag;
            return __generator(this, function (_a) {
                loginType = this.userInfoDomainService.userInfoAggregate.userInfo.loginType;
                shouldAddUFlag = ![ACCOUNT_TYPE.QQ, ACCOUNT_TYPE.WX].includes(loginType);
                return [2 /*return*/, this.qqShareRepository.shareToQQOrTIM(uinList, shouldAddUFlag)];
            });
        });
    };
    QQShareEntity.prototype.fetchFriendsInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.qqShareRepository.fetchFriendsInfo()];
            });
        });
    };
    QQShareEntity.prototype.fetchGroupMember = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.qqShareRepository.fetchGroupMember(groupId)];
            });
        });
    };
    QQShareEntity.prototype.fetchDiscussGroupMember = function (discussGroupId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.qqShareRepository.fetchDiscussGroupMember(discussGroupId)];
            });
        });
    };
    QQShareEntity.prototype.checkSkeyAuth = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.qqShareRepository.checkSkeyAuth()];
            });
        });
    };
    QQShareEntity.prototype.fetchGroupInfo = function (groupId) {
        return this.qqShareRepository.fetchGroupInfo(groupId);
    };
    QQShareEntity.prototype.fetchFriendInfo = function (uin) {
        return this.qqShareRepository.fetchFriendInfo(uin);
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], QQShareEntity.prototype, "checkIfCanShare", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], QQShareEntity.prototype, "setTipsAfterImport", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], QQShareEntity.prototype, "shareToQQOrTIM", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], QQShareEntity.prototype, "fetchFriendsInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], QQShareEntity.prototype, "fetchGroupMember", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], QQShareEntity.prototype, "fetchDiscussGroupMember", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], QQShareEntity.prototype, "checkSkeyAuth", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], QQShareEntity.prototype, "fetchGroupInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], QQShareEntity.prototype, "fetchFriendInfo", null);
    QQShareEntity = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __param(2, IUserInfoDomainService),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], QQShareEntity);
    return QQShareEntity;
}());
export default QQShareEntity;
